// extracted by mini-css-extract-plugin
export default {"separator":"seperatorComponent_separator__u5eeD"};